import {
  View,
  Text,
  FlatList,
  Animated,
  TouchableOpacity,
  Platform,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { femaleColor, maleColor, white } from "../../colors";
import MyText from "./MyText";
import { Entypo } from "@expo/vector-icons";
import childrenList from "../../api/get/childrenList";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import { useSelector } from "react-redux";
const Children = (props) => {
  const navigation = useNavigation();

  return (
    <TouchableOpacity
      activeOpacity={1}
      onPress={() =>
        !props.haveChat
          ? navigation.navigate("Consultation", {
              childId: props.item.id,
              childName: props.item.name,
              childImage: props.item.picURL,
              childGender: props.item.gender === "boy" ? "male" : "female",
            })
          : props.setChildren(props.item)
      }
      style={{
        marginHorizontal: 5,
        borderRadius: 15,
        padding: 5,
        zIndex: 100,
        borderWidth: 1,
        borderColor: props.gender === "male" ? maleColor : femaleColor,
        backgroundColor: props.selected
          ? props.gender === "male"
            ? maleColor
            : femaleColor
          : white,
        width: 100,
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      <MyText
        style={{
          color: !props.selected
            ? props.gender === "male"
              ? maleColor
              : femaleColor
            : white,
        }}
      >
        {props.name}
      </MyText>
    </TouchableOpacity>
  );
};

const AddChildren = (props) => {
  const navigation = useNavigation();
  return (
    <TouchableOpacity
      onPress={() => navigation.navigate("NewChildGenderChoose")}
      style={{
        zIndex: 100,
        marginHorizontal: 5,
        borderRadius: 15,
        padding: 5,
        borderWidth: 1,
        borderColor: maleColor,
        backgroundColor: maleColor,
        width: 100,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Entypo name="plus" size={20} color="white" />
    </TouchableOpacity>
  );
};
let prevBackground = "#fff";
export default function SelectChildrenMiniChat(props) {
  const myList = useRef(null);
  const [selected, setSelected] = useState({});
  const [animation, setAnimation] = useState(true);
  let mainAnimation = new Animated.Value(0);
  let animationForChangingColor = mainAnimation.interpolate({
    inputRange: [0, 100],
    outputRange: [
      prevBackground,
      animation
        ? selected.gender === "male"
          ? maleColor
          : femaleColor
        : "#fff",
    ],
  });
  Animated.timing(mainAnimation, {
    toValue: 100,
    duration: 400,
    useNativeDriver: false,
  }).start();
  useEffect(() => {
    let newColor = selected.gender === "male" ? maleColor : femaleColor;
    orderItems();
    setTimeout(() => {
      prevBackground = newColor;
    }, 500);
  }, [selected, animation]);

  const [children, setChildren] = useState([]);
  const isFocused = useIsFocused();

  const main = useSelector((store) => store.main);
  useEffect(() => {
    if (isFocused) {
      childrenList()
        .then(({ data }) => {
          if (data.status === 200) {
            setChildren(data.data);
            if (
              props.defaultChild !== undefined &&
              props.defaultChild !== null
            ) {
              let child = data.data.filter(
                (child) => child.id === props.defaultChild
              )[0];

              setSelected({
                ...child,
                gender: child.gender === "boy" ? "male" : "female",
              });
              props.setChild({
                ...child,
                gender: child.gender === "boy" ? "male" : "female",
              });
            } else {
              setSelected({
                ...data.data[0],
                gender: data.data[0].gender === "boy" ? "male" : "female",
              });
              props.setChild({
                ...data.data[0],
                gender: data.data[0].gender === "boy" ? "male" : "female",
              });
            }
            setTimeout(
              () =>
                myList?.current?.scrollToOffset({
                  animated: true,
                  offset: 0,
                }),
              500
            );
          }
        })
        .catch((err) => {});
    }
  }, [isFocused]);

  const orderItems = () => {
    let selectedItem = children.filter((item) => item.id === selected.id);

    let notSelectedItems = children.filter((item) => item.id !== selected.id);

    Platform.OS === "android" && main.rtl
      ? setChildren([...notSelectedItems, ...selectedItem])
      : setChildren([...selectedItem, ...notSelectedItems]);
    myList?.current?.scrollToOffset({
      animated: true,
      offset: 0,
    });
  };
  return (
    <View style={{ width: "94%" }}>
      <FlatList
        contentContainerStyle={{
          alignItems: "center",
          justifyContent: "flex-start",
        }}
        ref={myList}
        style={{ marginTop: 10, zIndex: 100 }}
        horizontal
        inverted={Platform.OS === "android" && main.rtl ? true : false}
        onScrollBeginDrag={() => setAnimation(false)}
        showsHorizontalScrollIndicator={false}
        ListFooterComponent={
          Platform.OS === "android" && main.rtl ? <></> : <AddChildren />
        }
        ListHeaderComponent={
          Platform.OS !== "android" || !main.rtl ? <></> : <AddChildren />
        }
        renderItem={({ item }) => (
          <Children
            setChildren={(item) => {
              props.setChild({
                ...item,
                gender: item.gender === "boy" ? "male" : "female",
              });
              setSelected({
                ...item,
                gender: item.gender === "boy" ? "male" : "female",
              });
              setAnimation(true);
            }}
            item={item}
            name={item.name}
            gender={item.gender === "boy" ? "male" : "female"}
            selected={item.id === selected.id}
            haveChat={item.counselingId !== null}
          />
        )}
        data={children}
      />
      <Animated.View
        style={{
          marginHorizontal: 5,
          width: 100,
          height: 40,
          marginTop: -16,
          backgroundColor: animationForChangingColor,
          zIndex: -100,
        }}
      >
        <MyText>{animationForChangingColor}</MyText>
      </Animated.View>
    </View>
  );
}
